<template>
   <div id="allbet" class="match-body" style="flex-direction: column;"> <!-- v-if="arr_allBetEvent" -->
      <!-- web header -->
      <div id="title-events-wrap" class="clearfix">
        <div id="title-events" class="clearfix">
          <div class="match-block">
            <div class="match-header">
              <div class="star-icon" @click.stop="favouriteAllBet(arr_allBetEvent)" :class="{ 'active': arr_allBetEvent && arr_allBetEvent.isFavourite? arr_allBetEvent.isFavourite:false }"></div>
              <div class="match-title" v-if="!loadingScreen" :title="arr_allBetEvent && arr_allBetEvent.lgecapt? arr_allBetEvent.lgecapt:'-'">{{ arr_allBetEvent && arr_allBetEvent.lgecapt? arr_allBetEvent.lgecapt:'-' }}</div>
            </div>
            <div class="match-date">{{ getDate(arr_allBetEvent) }}</div>
            <div class="match-content">
               <div class="side-star star-icon" @click.stop="favouriteTeam(arr_allBetEvent,'a')" :class="{ 'active': checkFavTeams('taid') }"></div>
               <div class="team">
                  <div class="team-icon"><img :src="arr_allBetEvent.talogo" v-if="arr_allBetEvent && arr_allBetEvent.talogo"></div>
                  <div class="team-name" :title="arr_allBetEvent && arr_allBetEvent.tacapt? arr_allBetEvent.tacapt:'-'" v-if="!loadingScreen">{{ arr_allBetEvent && arr_allBetEvent.tacapt? arr_allBetEvent.tacapt:'-' }}</div>
               </div>
               <div class="score notranslate" v-if="arr_allBetEvent && arr_allBetEvent.rb == 0">VS</div>
               <div class="score notranslate" v-else-if="arr_allBetEvent && arr_allBetEvent.score && arr_allBetEvent.score.FT">
                  <template v-if="arr_allBetEvent.score.FT.includes('Suspend')">
                     {{ sportAllBetLang['ALL_BET.SUSPEND'] }}{{ arr_allBetEvent.score.FT.split("Suspend")[1] }}
                  </template>
                  <template v-else>
                     {{ arr_allBetEvent.score.FT }}
                  </template>
               </div>
               <div class="score notranslate" v-else-if="arr_allBetEvent && arr_allBetEvent.score && arr_allBetEvent.score.HT">
                  <template v-if="arr_allBetEvent.score.HT.includes('Suspend')">
                     {{ sportAllBetLang['ALL_BET.SUSPEND'] }}{{ arr_allBetEvent.score.HT.split("Suspend")[1] }}
                  </template>
                  <template v-else>
                     {{ arr_allBetEvent.score.HT }}
                  </template>
               </div>
               <div class="score notranslate" v-else>0-0</div>
               <div class="team">
                  <div class="team-icon"><img :src="arr_allBetEvent.tblogo" v-if="arr_allBetEvent && arr_allBetEvent.tblogo"></div>
                  <div class="team-name" :title="arr_allBetEvent && arr_allBetEvent.tbcapt? arr_allBetEvent.tbcapt:'-'" v-if="!loadingScreen">{{ arr_allBetEvent && arr_allBetEvent.tbcapt? arr_allBetEvent.tbcapt:'-' }}</div>
               </div>
               <div class="side-star star-icon" @click.stop="favouriteTeam(arr_allBetEvent,'b')" :class="{ 'active': checkFavTeams('tbid') }"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- mobile header -->
      <div class="title-events-mobile-wrap">
        <!-- 初始畫面 -->
        <div class="title-events-mobile-content">
          <div class="title-events-mobile-header">
            <div class="title-events-mobile-icon star" @click.stop="favouriteAllBet(arr_allBetEvent)" :class="{ 'active': arr_allBetEvent && arr_allBetEvent.isFavourite? arr_allBetEvent.isFavourite:false }"></div>
            <div class="title-events-mobile-title" v-if="!loadingScreen" :title="arr_allBetEvent && arr_allBetEvent.lgecapt? arr_allBetEvent.lgecapt:'-'">{{ arr_allBetEvent && arr_allBetEvent.lgecapt? arr_allBetEvent.lgecapt:'-' }}</div>
            <div class="title-events-mobile-date">{{ getDate(arr_allBetEvent) }}</div>
          </div>

          <div class="title-events-mobile-teams">
            <div class="title-events-mobile-icon star" @click.stop="favouriteTeam(arr_allBetEvent,'a')" :class="{ 'active': checkFavTeams('taid') }"></div>
            <div class="title-events-mobile-team">
              <div class="team-logo team1"><img :src="arr_allBetEvent.talogo" v-if="arr_allBetEvent && arr_allBetEvent.talogo"></div>
              <div class="team-name" v-if="!loadingScreen">{{ arr_allBetEvent && arr_allBetEvent.tacapt? arr_allBetEvent.tacapt:'-' }}</div>
            </div>
            <div class="title-events-mobile-score notranslate" v-if="arr_allBetEvent && arr_allBetEvent.rb == 0">VS</div>
            <div class="title-events-mobile-score notranslate" v-else-if="arr_allBetEvent && arr_allBetEvent.score && arr_allBetEvent.score.FT">
               <template v-if="arr_allBetEvent.score.FT.includes('Suspend')">
                  {{ sportAllBetLang['ALL_BET.SUSPEND'] }}<br>{{ arr_allBetEvent.score.FT.split("Suspend")[1] }}
               </template>
               <template v-else>
                  {{ arr_allBetEvent.score.FT }}
               </template>
            </div>
            <div class="title-events-mobile-score notranslate" v-else-if="arr_allBetEvent && arr_allBetEvent.score && arr_allBetEvent.score.HT">
               <template v-if="arr_allBetEvent.score.HT.includes('Suspend')">
                  {{ sportAllBetLang['ALL_BET.SUSPEND'] }}<br>{{ arr_allBetEvent.score.HT.split("Suspend")[1] }}
               </template>
               <template v-else>
                  {{ arr_allBetEvent.score.HT }}
               </template>
            </div>
            <div class="title-events-mobile-score notranslate" v-else>0-0</div>
            <div class="title-events-mobile-team">
              <div class="team-logo team2"><img :src="arr_allBetEvent.tblogo" v-if="arr_allBetEvent && arr_allBetEvent.tblogo"></div>
              <div class="team-name" v-if="!loadingScreen">{{ arr_allBetEvent && arr_allBetEvent.tbcapt? arr_allBetEvent.tbcapt:'-' }}</div>
            </div>
            <div class="title-events-mobile-icon star" @click.stop="favouriteTeam(arr_allBetEvent,'b')" :class="{ 'active': checkFavTeams('tbid') }"></div>
          </div>

          <div class="title-events-mobile-toggle">
            <div class="toggle-btn">
              <div class="icon-mobile-left" :class="{ 'active':selectedTab == '1', 'non-rb': (arr_allBetEvent && arr_allBetEvent.rb != 1) }" @click="startTv(arr_allBetEvent)" v-if="arr_allBetEvent && arr_allBetEvent.rb != -1 && arr_allBetEvent.chid != 0"></div>
              <div class="icon-mobile-right" :class="selectedTab == '2'?'active':''" @click="changeVideo('anime', arr_allBetEvent)"></div>
            </div>
          </div>
        </div>

        <!-- Live 畫面 -->
        <!-- <div class="title-events-mobile-video title-events-mobile-live">
          <div class="back-btn" @click=closeVideo()>
            <svg viewBox="0 0 24 24">
              <path d="M15 18 L9 12 L15 6" stroke="white" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </div>
          <iframe id="bdIframe" allow="autoplay" frameborder="0" scrolling="no" :src="tvlink" style="width: 100%; height: 100%;" v-if="tvlink"></iframe>
          <div v-else style="width: fit-content; margin: auto; color: var(--live-box-score-text);">NO LIVE</div>
        </div> -->

        <!-- Anime 畫面 -->
        <!-- <div class="title-events-mobile-video title-events-mobile-anime">
          <div class="back-btn" @click=closeVideo()>
            <svg viewBox="0 0 24 24">
              <path d="M15 18 L9 12 L15 6" stroke="white" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </div>
          <iframe :src="animelink" frameborder="0" style="width: 100%; height: 100%;" v-if="animelink"></iframe>
          <div v-else style="width: fit-content; margin: auto; color: var(--live-box-score-text);">NO ANIME</div>
        </div> -->
      </div>

      <!-- nav -->
      <div class="tabs-wrap">
        <div class="tabs-nav">
          <button class="tabs-btn current" id="tab-overview" @click="displayContent('overview')">{{ arr_lang.sportAllBet['ALL_BET.OVERVIEW'] }}</button>
          <button class="tabs-btn" id="tab-odds" @click="displayContent('odds')" v-if="arr_allBetEvent && arr_allBetEvent.od && (arr_allBetEvent.od.length > 0 || Object.keys(arr_allBetEvent.od).length > 0)">{{ arr_lang.oddsConversionLang['ODDS_CONVERSION.ODDS'] }}</button>
          <button class="tabs-btn mob-only" id="tab-chat" @click="displayContent('chat')">{{ arr_lang.sportAllBet['ALL_BET.LIVE_CHAT'] }}</button>
          <button class="tabs-btn mob-only" id="tab-lineup" @click="displayContent('lineup')" v-if="arr_allBetEvent && arr_allBetEvent.lineup && Object.keys(arr_allBetEvent.lineup).length > 0">{{ arr_lang.sportAllBet['ALL_BET.LINE_UP'] }}</button>
        </div>
      </div>

      <!-- content -->
      <div class="tabs-content-wrap" v-if="arr_allBetEvent">
        <div class="tabs-content current" id="overview">
          <!-- 赔率 -->
          <div class="content-top" v-show="contentFlag.odds" v-if="arr_allBetEvent.od && (arr_allBetEvent.od.length > 0 || Object.keys(arr_allBetEvent.od).length > 0)">
            <!-- 賠率數據-電腦版+平板 -->
            <div class="table-wrapper">
              <div class="responsive-wrapper">
                <div class="odds-data-table">
                  <!-- 標題列 -->
                  <div class="odds-data-row odds-data-header">
                    <div class="odds-data-col odds-data-col1" :class="{'open': bmkToggle}">
                      <div class="odds-data-type-selector" ref="oddsselector" @click="toggleBmkDropdown()">
                        <div class="logo" :class="'bmk-'+selectedBmk"></div>
                        <!-- <svg class="dropdown-icon" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1L6 6L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg> -->
                        <svg class="dropdown-icon" viewBox="0 0 24 24" width="20" height="20">
                           <path d="M6 9l6 6 6-6" stroke="#FFF" stroke-width="2" fill="none" stroke-linecap="round"></path>
                        </svg>
                      </div>
                      <div class="odds-data-dropdown" ref="oddsdropdown">
                        <button @click="selectBmk('8')" class="dropdown-item bmk-8"></button>
                        <button @click="selectBmk('22')" v-if="arr_allBetEvent.od && arr_allBetEvent.od['22']" class="dropdown-item bmk-22"></button>
                        <button @click="selectBmk('3')" v-if="arr_allBetEvent.od && arr_allBetEvent.od['3']" class="dropdown-item bmk-3"></button>
                      </div>
                    </div>
                    <div class="odds-data-col odds-data-col2">
                      <span>1</span><span>X</span><span>2</span>
                    </div>
                    <div class="odds-data-col odds-data-col3">
                      <span>{{ arr_lang.sportAllBet['ALL_BET.AH'] }}</span>
                    </div>
                    <div class="odds-data-col odds-data-col4">
                      <span>{{ arr_lang.sportAllBet['ALL_BET.SCORE'] }}</span><span>{{ arr_lang.sportAllBet['ALL_BET.OVER'] }}</span><span>{{ arr_lang.sportAllBet['ALL_BET.UNDER'] }}</span>
                    </div>
                    <!-- <div class="odds-data-col odds-data-col5">
                      <span>角球</span><span>高于</span><span>低于</span>
                    </div> -->
                  </div>
                  <div class="odds-data-row odds-data-body bg-blue">
                    <div class="odds-data-col odds-data-col1"><span>{{ arr_lang.sportAllBet['ALL_BET.OPEN_ODDS'] }}</span></div>
                    <div class="odds-data-col odds-data-col2"> <!-- 1x2 -->
                      <span>{{ getOdd(arr_allBetEvent, '5', '1', 'odA') }}</span>
                      <span>{{ getOdd(arr_allBetEvent, '5', '1', 'odX') }}</span>
                      <span>{{ getOdd(arr_allBetEvent, '5', '1', 'odB') }}</span>
                    </div>
                    <div class="odds-data-col odds-data-col3"> <!-- AH -->
                      <span><em>{{ getHan(arr_allBetEvent, '1', '1', 'odA') }}</em>&nbsp;{{ getOdd(arr_allBetEvent, '1', '1', 'odA') }}</span>
                      <span><em>{{ getHan(arr_allBetEvent, '1', '1', 'odB') }}</em>&nbsp;{{ getOdd(arr_allBetEvent, '1', '1', 'odB') }}</span>
                    </div>
                    <div class="odds-data-col odds-data-col4"> <!-- OU -->
                      <span class="highlight">{{ getOdd(arr_allBetEvent, '3', '1', 'han') }}</span>
                      <span>{{ getOdd(arr_allBetEvent, '3', '1', 'odA') }}</span>
                      <span>{{ getOdd(arr_allBetEvent, '3', '1', 'odB') }}</span>
                    </div>
                    <!-- <div class="odds-data-col odds-data-col5">
                      <span>3.20</span><span>1.88</span><span>2.00</span>
                    </div> -->
                  </div>
                  <div class="odds-data-row odds-data-body bg-yellow last-row">
                    <div class="odds-data-col odds-data-col1"><span>{{ arr_lang.sportAllBet['ALL_BET.PREMATCH_ODDS'] }}</span></div>
                    <div class="odds-data-col odds-data-col2">
                      <span>{{ getOdd(arr_allBetEvent, '5', '2', 'odA') }}</span>
                      <span>{{ getOdd(arr_allBetEvent, '5', '2', 'odX') }}</span>
                      <span>{{ getOdd(arr_allBetEvent, '5', '2', 'odB') }}</span>
                    </div>
                    <div class="odds-data-col odds-data-col3">
                      <span><em>{{ getHan(arr_allBetEvent, '1', '2', 'odA') }}</em>&nbsp;{{ getOdd(arr_allBetEvent, '1', '2', 'odA') }}</span>
                      <span><em>{{ getHan(arr_allBetEvent, '1', '2', 'odB') }}</em>&nbsp;{{ getOdd(arr_allBetEvent, '1', '2', 'odB') }}</span>
                    </div>
                    <div class="odds-data-col odds-data-col4">
                      <span class="highlight">{{ getOdd(arr_allBetEvent, '3', '2', 'han') }}</span>
                      <span>{{ getOdd(arr_allBetEvent, '3', '2', 'odA') }}</span>
                      <span>{{ getOdd(arr_allBetEvent, '3', '2', 'odB') }}</span>
                    </div>
                    <!-- <div class="odds-data-col odds-data-col5">
                      <span>3.40</span><span>1.80</span><span>2.10</span>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- table-wrapper 賠率數據-手機板 -->
            <div class="odds-info-wrapper">
               <div class="odds-overview-header">
                  <span class="header-title">{{ arr_lang.oddsConversionLang['ODDS_CONVERSION.ODDS'] }}</span>
                  <!-- <a href="#" class="header-more" data-tab="odds">
                     more
                     <svg class="header-more-icon" viewBox="0 0 24 24" width="20" height="20">
                        <path d="M9 6l6 6-6 6" stroke="#FFF" stroke-width="2" fill="none" stroke-linecap="round"></path>
                     </svg>
                  </a> -->
               </div>
               <!-- 第一列 Tabs -->
               <div class="odds-info-tabs">
                  <button class="tab-btn" :class="{'active': oddsBettyp == '5'}" @click="selectOddsBettyp('5')">1x2</button>
                  <button class="tab-btn" :class="{'active': oddsBettyp == '1'}" @click="selectOddsBettyp('1')">{{ arr_lang.sportAllBet['ALL_BET.AH_short'] }}</button>
                  <button class="tab-btn" :class="{'active': oddsBettyp == '3'}" @click="selectOddsBettyp('3')">{{ arr_lang.sportAllBet['ALL_BET.SCORE'] }}</button>
                  <!-- <button class="tab-btn">角球</button> -->
               </div>

               <!-- 第二列 Switch -->
               <div class="odds-info-switch">
                  <div class="switch-btn" :class="{'active': oddsSwitchToggle['pre']}" @click="oddsSwitch('pre')" data-switch="pre">{{ arr_lang.sportAllBet['ALL_BET.PREMATCH_ODDS'] }}</div>
                  <!-- <div class="switch-btn" :class="{'active': oddsSwitchToggle['live']}" @click="oddsSwitch('live')" data-switch="live">赛中赔率</div> -->
               </div>

               <!-- Table -->
               <div class="odds-info-table-wrap">
                  <table class="odds-info-table">
                     <thead>
                        <tr>
                           <th></th>
                           <th colspan="3" v-if="oddsBettyp == '5'">1x2</th>
                           <th colspan="3" v-else-if="oddsBettyp == '1'">{{ arr_lang.sportAllBet['ALL_BET.AH'] }}</th>
                           <th colspan="3" v-else-if="oddsBettyp == '3'">{{ arr_lang.sportAllBet['ALL_BET.SCORE'] }}</th>
                        </tr>
                     </thead>
                     <tbody>
                        <!-- 初始賠率 -->
                        <tr class="brand-row">
                           <td rowspan="3">bet365</td>
                           <td class="odds-cell">{{ getOdd(arr_allBetEvent, oddsBettyp, '1', (oddsBettyp=='5'?'odA':'han')) }}</td>
                           <td class="odds-cell">{{ getOdd(arr_allBetEvent, oddsBettyp, '1', (oddsBettyp=='5'?'odX':'odA')) }}</td>
                           <td class="odds-cell">{{ getOdd(arr_allBetEvent, oddsBettyp, '1', 'odB') }}</td>
                        </tr>
                        <!-- 赛前賠率 -->
                        <tr class="pre-row" :class="{'hidden': !oddsSwitchToggle['pre']}">
                           <td class="odds-cell">{{ getOdd(arr_allBetEvent, oddsBettyp, '2', (oddsBettyp=='5'?'odA':'han')) }}</td>
                           <td class="odds-cell">{{ getOdd(arr_allBetEvent, oddsBettyp, '2', (oddsBettyp=='5'?'odX':'odA')) }}</td>
                           <td class="odds-cell">{{ getOdd(arr_allBetEvent, oddsBettyp, '2', 'odB') }}</td>
                        </tr>
                        <!-- 赛中賠率 -->
                        <!-- <tr class="live-row" :class="{'hidden': !oddsSwitchToggle['live']}">
                           <td class="odds-cell">7.90</td>
                           <td class="odds-cell">6.10</td>
                           <td class="odds-cell">1.30</td>
                        </tr> -->
                     </tbody>
                  </table>
               </div>

               <!-- 註解列 -->
               <div class="odds-info-annotation-row">
                  <div class="annotation-item icon-blue">
                     <div class="annotation-icon"></div>
                     <span>{{ arr_lang.sportAllBet['ALL_BET.OPEN_ODDS'] }}</span>
                  </div>
                  <div class="annotation-item icon-yellow">
                     <div class="annotation-icon"></div>
                     <span>{{ arr_lang.sportAllBet['ALL_BET.PREMATCH_ODDS'] }}</span>
                  </div>
                  <!-- <div class="annotation-item icon-green">
                     <div class="annotation-icon"></div>
                     <span>赛中赔率</span>
                  </div> -->
               </div>
            </div>
          </div>
          <!-- 赔率 end -->
          <div class="content-middle">
            <div class="container-inner container-inner-left" v-show="contentFlag.video || contentFlag.livetext">
              <div class="videos-wrap" v-show="contentFlag.video">
                  <div class="content-header">
                     <div class="content-title">
                     <span class="videos-title-text" :class="checkTitle(arr_allBetEvent.lgecapt,'lge')">{{ arr_allBetEvent.lgecapt }}</span>
                     <span class="videos-title-divider">|</span>
                     <span class="videos-title-date" id="videos-date">{{ getDate(arr_allBetEvent) }}</span>
                     </div>
                     <div class="videos-tabs-wrap">
                     <div class="videos-tabs">
                        <button class="videos-tab-btn videos-tab-live" :class="selectedTab == '1'?'active':''" @click="startTv(arr_allBetEvent)" v-if="arr_allBetEvent.rb != -1 && arr_allBetEvent.chid != 0">
                           <div class="videos-tab-icon live"></div>
                        </button>
                        <button class="videos-tab-btn videos-tab-anime" :class="selectedTab == '2'?'active':''" @click="changeVideo('anime', arr_allBetEvent)">
                           <div class="videos-tab-icon anime"></div>
                        </button>
                     </div>
                     </div>
                  </div>
                  <div class="videos-content">
                     <div class="videos-screen live" :class="selectedTab == '1'?'active':''" v-if="selectedTab == '1'">
                        <iframe id="bdIframe" allow="autoplay" frameborder="0" scrolling="no" :src="tvlink" style="width: 100%; height: 100%;" v-if="tvlink"></iframe>
                        <div v-else style="width: fit-content; margin: auto; color: var(--live-box-score-text);">NO LIVE</div>
                     </div>
                     <div class="videos-screen anime" :class="selectedTab == '2'?'active':''" v-else-if="selectedTab == '2'">
                        <!-- <iframe src="https://zhibo.feijing88.com/football/detail.html?matchId=2769152&amp;accessKey=aJLBMV5nq4henA3cDQvcK4YuIpKIFzmCx0q5&amp;ts=1745481831585&amp;auth=78098FEAA9679179B6A57747C3CE506B&amp;statsPanel=HIDE" frameborder="0" style="width: 100%; height: 100%;"></iframe> -->
                        <iframe :src="animelink" frameborder="0" style="width: 100%; height: 100%;" v-if="animelink"></iframe>
                        <div v-else style="width: fit-content; margin: auto; color: var(--live-box-score-text);">NO ANIME</div>
                     </div>
                  </div>
              </div>
              <div class="live-text-wrap" v-show="contentFlag.livetext" v-if="arr_allBetEvent.livetext && (arr_allBetEvent.livetext.length > 0 || Object.keys(arr_allBetEvent.livetext).length > 0)">
                  <div class="content-header">
                     <div class="content-title">{{ arr_lang.sportAllBet['ALL_BET.LIVE_TEXT'] }}</div>
                  </div>
                  <div class="live-text-team-row">
                     <div class="live-text-team-left">
                        <div class="team-icon live-text-team-icon team-a"><img :src="arr_allBetEvent.talogo" v-if="arr_allBetEvent.talogo"></div>
                        <div class="live-text-team-name" :class="checkTitle(arr_allBetEvent.tacapt, 'team')">{{ arr_allBetEvent.tacapt }}</div>
                     </div>
                     <div class="analysis-padding"></div>
                     <div class="live-text-team-right">
                        <div class="live-text-team-name" :class="checkTitle(arr_allBetEvent.tbcapt, 'team')">{{ arr_allBetEvent.tbcapt }}</div>
                        <div class="team-icon live-text-team-icon team-b"><img :src="arr_allBetEvent.tblogo" v-if="arr_allBetEvent.tblogo"></div>
                     </div>
                  </div>
                  <div class="live-text-content">
                     <div class="live-text-row">
                        <div class="live-text-score">{{ getLiveTextScore(arr_allBetEvent.rb_timer_status, arr_allBetEvent.score) }}</div>
                     </div>
                     <div class="live-text-message-list" id="liveTextMessages">
                        <div class="live-text-msg-block" v-for="(value, index) in arr_allBetEvent.livetext" v-if="(value.happenTime && (value.actCap1 || value.act1)) || (value.happenTime && value.direction == 3)">
                           <div class="live-text-time-circle">{{ value.direction == 3? value.act1: value.happenTime }}</div>
                           <template v-if="value.direction == 1">
                              <div class="live-text-msg live-text-msg-left">
                                 <template v-if="value.actCap1">{{ value.actCap1 }}
                                    <template v-if="value.actCap3 || value.act3">
                                       <template v-if="value.act2">{{ value.act2 }}</template>
                                       <template v-if="value.actCap2">{{ value.actCap2 }}</template>
                                    </template>
                                 </template>
                                 <template v-if="value.actCap1 && value.act1"> | </template>
                                 <template v-if="value.act1"><span class="strong">{{ value.act1 }}</span></template>

                                 <template v-if="value.actCap3 || value.act3">
                                    <template v-if="value.actCap3 || value.act3"><br></template>
                                    <template v-if="value.actCap3">{{ value.actCap3 }}</template>
                                    <template v-if="value.actCap3 && value.act3"> | </template>
                                    <template v-if="value.act3"><span class="strong">{{ value.act3 }}</span></template>
                                 </template>
                                 <template v-else>
                                    <template v-if="value.actCap2 || value.act2"><br></template>
                                    <template v-if="value.actCap2">{{ value.actCap2 }}</template>
                                    <template v-if="value.actCap2 && value.act2"> | </template>
                                    <template v-if="value.act2"><span class="strong">{{ value.act2 }}</span></template>
                                 </template>
                              </div>
                           </template>
                           <template v-else-if="value.direction == 2">
                              <div class="live-text-msg live-text-msg-right">
                                 <template v-if="value.act1"><span class="strong">{{ value.act1 }}</span></template>
                                 <template v-if="value.actCap1 && value.act1"> | </template>
                                 <template v-if="value.actCap1">{{ value.actCap1 }}
                                    <template v-if="value.actCap3 || value.act3">
                                       <template v-if="value.act2">{{ value.act2 }}</template>
                                       <template v-if="value.actCap2">{{ value.actCap2 }}</template>
                                    </template>
                                 </template>
                                 
                                 <template v-if="value.actCap3 || value.act3">
                                    <template v-if="value.actCap3 || value.act3"><br></template>
                                    <template v-if="value.act3"><span class="strong">{{ value.act3 }}</span></template>
                                    <template v-if="value.actCap3 && value.act3"> | </template>
                                    <template v-if="value.actCap3">{{ value.actCap3 }}</template>
                                 </template>
                                 <template v-else>
                                    <template v-if="value.actCap2 || value.act2"><br></template>
                                    <template v-if="value.act2"><span class="strong">{{ value.act2 }}</span></template>
                                    <template v-if="value.actCap2 && value.act2"> | </template>
                                    <template v-if="value.actCap2">{{ value.actCap2 }}</template>
                                 </template>
                              </div>
                           </template>
                        </div>
                     </div>
                  </div>
              </div>
            </div>
            <div class="container-inner container-inner-right" v-show="contentFlag.chat || contentFlag.analysis">
              <div class="chat-room-wrap" v-show="contentFlag.chat">
                <div class="content-header">
                  <div class="content-title">{{ arr_lang.sportAllBet['ALL_BET.LIVE_CHAT'] }}</div>
                  <button class="chat-room-toggle-btn" id="chatToggleBtn" aria-label="Toggle Chat" @click="toggleChatroom">
                    <svg class="chat-room-toggle-icon" viewBox="0 0 24 24" width="20" height="20" :class="{ 'collapsed': !chatroom }">
                      <path d="M6 9l6 6 6-6" stroke="#FFF" stroke-width="2" fill="none" stroke-linecap="round"></path>
                    </svg>
                  </button>
                </div>
                <div class="chat-room-body" id="chatRoomBody" :class="{ 'hidden': !chatroom }">
                  <div class="chat-room-message">
                     <div class="chat-room-meta">
                        <span class="chat-room-user">Alice</span>
                        <span class="chat-room-time">09:39 AM</span>
                     </div>
                     <div class="chat-room-text">Hi there! 😊 How's it going?</div>
                  </div>
                  <div class="chat-room-message">
                     <div class="chat-room-meta">
                        <span class="chat-room-user">Bob_88</span>
                        <span class="chat-room-time">09:39 AM</span>
                     </div>
                     <div class="chat-room-text">Doing great! Just got off work 🏃‍♂️</div>
                  </div>
               </div>
                <div class="chat-room-footer">
                  <input type="text" class="chat-room-input" :placeholder="arr_lang.sportAllBet['ALL_BET.WRITE_SOMETHING']">
                  <button class="chat-room-send-btn" aria-label="Send Message"></button>
                </div>
              </div>
              <div class="data-analysis-wrap" v-show="contentFlag.analysis" v-if="arr_allBetEvent.anlysis && arr_allBetEvent.anlysis.length > 0">
                  <div class="content-header">
                     <div class="content-title">{{ arr_lang.sportAllBet['ALL_BET.ANALYSIS'] }}</div>
                  </div>
                  <div class="data-analysis-team-row">
                     <div class="data-analysis-team">
                        <div class="team-icon data-analysis-team-icon team-a"><img :src="arr_allBetEvent.talogo" v-if="arr_allBetEvent.talogo"></div>
                        <div class="data-analysis-team-name" :class="checkTitle(arr_allBetEvent.tacapt,'team')">{{ arr_allBetEvent.tacapt }}</div>
                     </div>
                     <div  class="data-analysis-team">
                        <div class="analysis-padding"></div>
                     </div>
                     <div class="data-analysis-team">
                        <div class="data-analysis-team-name" :class="checkTitle(arr_allBetEvent.tbcapt,'team')">{{ arr_allBetEvent.tbcapt }}</div>
                        <div class="team-icon data-analysis-team-icon team-b"><img :src="arr_allBetEvent.tblogo" v-if="arr_allBetEvent.tblogo"></div>
                     </div>
                  </div>
                  <div class="data-analysis-content-row" v-for="(value, index) in arr_allBetEvent.anlysis" :key="index">
                     <div class="data-analysis-num data-analysis-num-left"><span :style="getAnalysisStyle('left', value[Object.keys(value)[0]].t)">{{ value[Object.keys(value)[0]].a }}</span></div>
                     <div class="data-analysis-label">{{ value[Object.keys(value)[0]].cap }}</div>
                     <div class="data-analysis-num data-analysis-num-right"><span :style="getAnalysisStyle('right', value[Object.keys(value)[0]].t)">{{ value[Object.keys(value)[0]].b }}</span></div>
                  </div>
              </div>
            </div>
          </div>
          <div class="content-bottom">
            <div class="jersey-wrap" v-show="contentFlag.lineup" v-if="arr_allBetEvent.lineup && Object.keys(arr_allBetEvent.lineup).length > 0">
               <div class="content-header">
                  <div class="content-title">{{ arr_lang.sportAllBet['ALL_BET.LINE_UP'] }}</div>
               </div>
               <div class="jersey-team-row">
                  <div class="jersey-team-col jersey-team-left">
                     <div class="team-icon jersey-team-icon team-a"><img :src="arr_allBetEvent.talogo" v-if="arr_allBetEvent.talogo"></div>
                     <div class="jersey-team-name">{{ arr_allBetEvent.tacapt }}</div>
                  </div>
                  <div class="jersey-team-col jersey-team-right">
                     <div class="team-icon jersey-team-icon team-b"><img :src="arr_allBetEvent.tblogo" v-if="arr_allBetEvent.tblogo"></div>
                     <div class="jersey-team-name">{{ arr_allBetEvent.tbcapt }}</div>
                  </div>
               </div>
               <div class="jersey-section-title">{{ arr_lang.sportAllBet['ALL_BET.START_LINE_UP'] }}</div>
               <div class="jersey-player-list">
                  <div class="jersey-player-row" v-for="(row, index) in splitLineups" :key="'lineup-'+index">
                     <div class="jersey-player-group jersey-left">
                        <div class="jersey-player-item" v-if="row.homeLeft">
                           <div class="jersey-player-icon icon-left">{{ row.homeLeft.number }}</div>
                           <div class="jersey-player-name">{{ row.homeLeft.name }}</div>
                        </div>
                        <div class="jersey-player-item" v-if="row.homeRight">
                           <div class="jersey-player-icon icon-left">{{ row.homeRight.number }}</div>
                           <div class="jersey-player-name">{{ row.homeRight.name }}</div>
                        </div>
                     </div>
                     <div class="jersey-player-group jersey-right">
                           <div class="jersey-player-item" v-if="row.awayLeft">
                              <div class="jersey-player-icon icon-right">{{ row.awayLeft.number }}</div>
                              <div class="jersey-player-name">{{ row.awayLeft.name }}</div>
                           </div>
                           <div class="jersey-player-item" v-if="row.awayRight">
                              <div class="jersey-player-icon icon-right">{{ row.awayRight.number }}</div>
                              <div class="jersey-player-name">{{ row.awayRight.name }}</div>
                           </div>
                     </div>
                  </div>
               </div>
               <div class="jersey-section-title substitute">{{ arr_lang.sportAllBet['ALL_BET.SUB_LINE_UP'] }}</div>
               <div class="jersey-player-list">
                  <div class="jersey-player-row" v-for="(row, index) in splitBackups" :key="'backup-'+index">
                     <div class="jersey-player-group jersey-left">
                        <div class="jersey-player-item" v-if="row.homeLeft">
                           <div class="jersey-player-icon icon-left">{{ row.homeLeft.number }}</div>
                           <div class="jersey-player-name">{{ row.homeLeft.name }}</div>
                        </div>
                        <div class="jersey-player-item" v-if="row.homeRight">
                           <div class="jersey-player-icon icon-left">{{ row.homeRight.number }}</div>
                           <div class="jersey-player-name">{{ row.homeRight.name }}</div>
                        </div>
                     </div>
                     <div class="jersey-player-group jersey-right">
                           <div class="jersey-player-item" v-if="row.awayLeft">
                              <div class="jersey-player-icon icon-right">{{ row.awayLeft.number }}</div>
                              <div class="jersey-player-name">{{ row.awayLeft.name }}</div>
                           </div>
                           <div class="jersey-player-item" v-if="row.awayRight">
                              <div class="jersey-player-icon icon-right">{{ row.awayRight.number }}</div>
                              <div class="jersey-player-name">{{ row.awayRight.name }}</div>
                           </div>
                     </div>
                  </div>
               </div>
            </div>
          </div>
        </div>
        <!-- <div class="tabs-content" id="odds">赔率內容</div> -->
        <!-- <div class="tabs-content mob-only" id="chat">聊天內容</div>
        <div class="tabs-content mob-only" id="lineup">陣容內容</div> -->
      </div>
      <div class="tabs-content-wrap" v-else>
         <div data-v-549f1e7b class="no-data data-get-empty1">
            <template v-if="skinTheme==2">
               <div data-v-549f1e7b class="empty-favorite-bg" style="background-image: url('assets/images/mob/noMatch2.png');"></div>
            </template>
            <template v-else>
               <div data-v-549f1e7b class="empty-favorite-bg" style="background-image: url('assets/images/mob/noMatch.svg');"></div>
            </template>
            <p data-v-549f1e7b style="color: rgb(165, 169, 179);">{{ arr_lang.sportTable['SPORT_TABLE.EMPTY'] }}</p>
         </div>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@/vue/events/event-bus'
import sportFavourite from '@/vue/mixins/favourite'

export default {
   mixins: [sportFavourite],
   computed: {
      ...mapGetters([
         'arr_allBetEvent',
         'arr_lang',
         'selectedSport',
         'favouriteTeams',
         'skinTheme',
         'isMobile',
         'loadingScreen',
         'sportAllBetLang',
      ]),
      splitLineups() {
         return this.arr_allBetEvent && this.arr_allBetEvent.lineup? 
            this.splitTwoColumns(this.arr_allBetEvent.lineup.homeLineup,this.arr_allBetEvent.lineup.awayLineup) : [];
      },
      splitBackups() {
        return this.arr_allBetEvent && this.arr_allBetEvent.lineup? 
            this.splitTwoColumns(this.arr_allBetEvent.lineup.homeBackup,this.arr_allBetEvent.lineup.awayBackup) : [];
      },
   },
   watch: {
      'arr_allBetEvent.anime'(newVal) {
         if (this.animelink == null) {
            this.animelink = newVal;
         }
      }
   },
   data(){
      return{
         heightPX : window.innerHeight,
         token: window.token,
         cloneEventAllBet: null,
         mainMarketList: null,
         allBetRefreshTimer: 90,
         allBetTimerId: null,
         matchDate: '',
         matchDateInterval: null,
         days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
         months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
         orientation:(window.outerWidth < window.outerHeight || (window.orientation!=undefined && window.orientation===0) || window.matchMedia("(orientation: portrait)").matches) ? 0 : 90,
         tvlink: null,
         animelink: null,
         chatroom: true,
         contentFlag: {
            video: true,
            livetext: true,
            chat: true,
            analysis: true,
            lineup: true,
            odds: true,
         },
         bmkToggle: false,
         selectedBmk: '8',
         oddsSwitchToggle: {
            'pre': false,
            'live': false,
         },
         oddsBettyp: '5',
         selectedTab: '2',
      }
   },
   methods:{
      reloadAllBetTable(token_val='') {
        if(token_val == ''){
          token_val = token.arr_5
        }
        this.cloneEventAllBet = _.cloneDeep(this.$store.getters.arr_allBetEvent)
        this.clearAllBetTimer()
        this.$store.dispatch('getSportAllBet', {
          token: token_val,
          inAllBet: true,
          event: this.$store.getters.arr_allBetEvent,
          callback: ((res) => {
            this.allBetRefreshTimer = this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key ? 30 : 90
            this.startAllBetTimer()
            this.mainMarketList = _.cloneDeep(this.$store.getters.arr_allBetEvent)
            // this.syncMainMarket()
            // this.$nextTick(() => {
            //   EventBus.$emit('diffOdd', this.cloneEventAllBet)
            // })
            this.$store.commit('REFRESHALLBET', false)
          }).bind(this)
        })
      },
      clearAllBetTimer() {
        clearInterval(this.allBetTimerId)
        this.allBetTimerId = null
      },
      startAllBetTimer() {
        if(this.allBetTimerId == null){
          this.allBetTimerId = setInterval(() => {
            if(this.allBetRefreshTimer - 1 < 0) {
              this.reloadAllBetTable(token.arr_1)
            } else {
              this.allBetRefreshTimer -= 1;
            }
          },1000);
        }
      },
      updateMatchDate() {
         const now = new Date();

         const selectedTimezone = this.$store.getters.selected_timezone;
         const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
         const tzDate = new Date(utc + (selectedTimezone * 3600000));
         const formatted = `${this.days[tzDate.getDay()]} ${this.months[tzDate.getMonth()]} ${String(tzDate.getDate()).padStart(2, '0')} ${tzDate.getFullYear()} ${String(tzDate.getHours()).padStart(2, '0')}:${String(tzDate.getMinutes()).padStart(2, '0')}:${String(tzDate.getSeconds()).padStart(2, '0')}`;
         
         // const formatted = `${this.days[now.getDay()]} ${this.months[now.getMonth()]} ${String(now.getDate()).padStart(2, '0')} ${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
         this.matchDate = formatted;
      },
      changeVideo(type, allBet) {
         this.displayContent('overview')
         if(type == 'live'){
            this.selectedTab = '1'
         }else if(type == 'anime'){
            this.selectedTab = '2'
         }
      },
      startTv(allBet){ 
         if(allBet && allBet.rb == 1) {
            this.$ajax({
               url: _baseUrl + '/livetv',
               type: 'post',
               data: {
                     chlid: allBet.chid? allBet.chid:allBet.ch, 
                     eventid: allBet.eveid,
                     sptid: allBet.sprtid? allBet.sprtid:allBet.sptid,
                     league: allBet.lgecapt,
                     tacap: allBet.tacapt,
                     tbcap: allBet.tbcapt
               }
            }).then(response => {
                  if(response!='error'){
                     this.tvlink = response;
                     this.changeVideo('live', allBet)
                     // this.closeTvWindow=false
                  }else{
                     // alert(this.arr_lang.LivetvLang['LIVETV.Stream_Error'])
                     this.tvlink = null;
                     this.changeVideo('anime', allBet)
                  }
            })
         }
      },
      closeVideo() {
         $('.title-events-mobile-video').removeClass('active')
      },
      toggleChatroom() {
         this.chatroom = !this.chatroom
      },
      getAnalysisStyle(position, t) {
         const defaultStyle = {
            backgroundColor: 'transparent',
            color: 'var(--live-box-score-text)'
         };

         const styles = {
            left: { backgroundColor: '#4360ec', color: '#fff' },
            right: { backgroundColor: '#ffdd00', color: '#000' }
         };

         if ((position === 'left' && t === 'a') || (position === 'right' && t === 'b')) {
            return styles[position];
         }

         return defaultStyle;
      },
      splitTwoColumns(home, away) {
         const homeArr = Array.isArray(home) ? home : [];
         const awayArr = Array.isArray(away) ? away : [];

         const homeMid = Math.ceil(homeArr.length / 2);
         const awayMid = Math.ceil(awayArr.length / 2);

         const maxLen = Math.max(homeMid, awayMid);
         const result = [];

         for (let i = 0; i < maxLen; i++) {
            result.push({
               homeLeft: homeArr[i] || null,
               homeRight: homeArr[i + homeMid] || null,
               awayLeft: awayArr[i] || null,
               awayRight: awayArr[i + awayMid] || null
            });
         }

         return result;
      },
      getLiveTextScore(rb_timer_status, rb_score) {
         if(rb_timer_status) {
            return rb_timer_status + (rb_score && rb_score[rb_timer_status]? ' '+rb_score[rb_timer_status]: '')
         }
         return ''
      },
      displayContent(type) {
         if(!$('.tabs-btn#tab-'+type).hasClass('current')) {
            $('.tabs-btn').removeClass('current')
            $('.tabs-btn#tab-'+type).addClass('current')
         }

         const defaultFlags = {
            video: false,
            livetext: false,
            chat: false,
            analysis: false,
            lineup: false,
            odds: false,
         };

         if (type === 'overview') {
            for (let key in defaultFlags) {
               defaultFlags[key] = true;
            }
         } else {
            defaultFlags[type] = true;
         }

         this.contentFlag = defaultFlags;
      },
      checkFavTeams(team) {
         if(this.arr_allBetEvent && this.arr_allBetEvent[team]) {
            if(this.favouriteTeams && this.favouriteTeams[this.selectedSport] && this.favouriteTeams[this.selectedSport].indexOf(this.arr_allBetEvent[team])>=0) {
               return true
            }
         }
         return false
      },
      getDate(event){
         if(event!=null){
            return event.evedt
         }
      },
      checkTitle(title, mod) {
         if(title && title.length > 20) {
            if(mod && mod=='lge') {
               return 'text-ellipsis';
            }else if(mod && mod == 'team'){
               return 'text-ellipsis-team';
            }
         }
         return '';
      },
      toggleBmkDropdown() {
         if($('.odds-data-dropdown').length > 0 && $('.content-top').children('.odds-data-dropdown').length <= 0) {
            $('.content-top').append($('.odds-data-dropdown'));
         }
         this.bmkToggle = !this.bmkToggle
         if (this.bmkToggle) {
            $('.odds-data-dropdown').addClass('open')
            this.$nextTick(() => this.updateDropdownPosition());
         } else {
            $('.odds-data-dropdown').removeClass('open')
         }
      },
      selectBmk(bmk){
         this.bmkToggle = false
         $('.odds-data-dropdown').removeClass('open')
         this.selectedBmk = bmk
      },
      updateDropdownPosition() {
         const selector = this.$refs.oddsselector;
         const dropdown = this.$refs.oddsdropdown;
         if (!selector || !dropdown) return;

         const rect = selector.getBoundingClientRect();

         if(window.innerWidth >= 1366) {
            dropdown.style.top = '520px';
            dropdown.style.left = rect.left + 'px';
         } else if (window.innerWidth >= 481 && window.innerWidth < 1366) {
            dropdown.style.top = '48px';
            dropdown.style.left = '23px';
         } else {
            this.bmkToggle = false
            $('.odds-data-dropdown').removeClass('open')
         }
      },
      handleResize() {
         this.orientation =(window.outerWidth < window.outerHeight || (window.orientation!=undefined && window.orientation===0) || window.matchMedia("(orientation: portrait)").matches) ? 0 : 90;
         if (this.bmkToggle) {
            this.updateDropdownPosition();
         }
      },
      getOdd(event, bettyp, type, team) {
         var plytyp = event.rb == 1? '3':'2'
         if(event.od && event.od[this.selectedBmk] 
            && event.od[this.selectedBmk][bettyp] 
            && event.od[this.selectedBmk][bettyp][type] 
            && event.od[this.selectedBmk][bettyp][type][team]) {
               return event.od[this.selectedBmk][bettyp][type][team]
         }
         return '-'
      },
      getHan(event, bettyp, type, team) {
         var plytyp = event.rb == 1? '3':'2'
         if(event.od && event.od[this.selectedBmk] 
            && event.od[this.selectedBmk][bettyp] 
            && event.od[this.selectedBmk][bettyp][type] 
            && event.od[this.selectedBmk][bettyp][type]['han']) {
               var ret = (event.od[this.selectedBmk][bettyp][type]['han']).toString()
               if(parseFloat(ret) != 0) {
                  if (ret.substring(0, 1) != '-') {
                     if (team == 'odA') {
                        ret = '+'+ret
                     } else {
                        ret = '-'+ret
                     }
                  } else {
                     if (team == 'odA') {
                        ret = '-'+ret.slice(1)
                     } else {
                        ret = '+'+ret.slice(1)
                     }
                  }
               }
               return ret
         }
         return ''
      },
      oddsSwitch(swt) {
         this.oddsSwitchToggle[swt] = !this.oddsSwitchToggle[swt]
      },
      selectOddsBettyp(bty) {
         this.selectedBmk = '8'
         this.oddsBettyp = bty
      },
   },
   beforeMount() {
      $( ".scroll" ).scrollTop( 0 );
      this.$store.commit('LOADINGSCREEN', true)
      this.allBetRefreshTimer = this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key ? 30 : 90
      this.mainMarketList = _.cloneDeep(this.$store.getters.arr_allBetEvent)
      this.startAllBetTimer()

      EventBus.$off('startTvDefault')
      EventBus.$on('startTvDefault', ((event) => {
         // this.changeVideo('live', event)
         this.startTv(event)
      }).bind(this))
   },
   mounted() {
      this.updateMatchDate();
      this.matchDateInterval = setInterval(this.updateMatchDate, 1000);
      window.addEventListener('resize', this.handleResize, { passive: true });
   },
   beforeDestroy() {
      clearInterval(this.matchDateInterval);
      window.removeEventListener('resize', this.handleResize, { passive: true });
   },
   destroyed(){
      this.clearAllBetTimer()
   },
}
</script>

<style scoped lang="scss">
   .text-ellipsis {
      width: 200px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
   }
   .text-ellipsis-team {
      width: 100px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
   }
   .analysis-padding {
      padding: 24px 30px;
   }
</style>


// WEBPACK FOOTER //
// resources/score/vue/apps/sport/allBet/allBet2.vue